// extracted by mini-css-extract-plugin
module.exports = {"Alert":"Alert_Alert__btrys","Wrapper":"Alert_Wrapper__MBQ_E","CloseIcon":"Alert_CloseIcon__3knbn","InfoIcon":"Alert_InfoIcon__3i4Ng"};